import React from 'react';
import { makeStyles, withStyles  } from '@material-ui/core/styles';
import { Typography, Dialog, DialogActions, DialogContent, Button, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import MuiDialogTitle from '@material-ui/core/DialogTitle';

const useStyles = makeStyles(() => ({
    dialogPaper: {
        margin: '10px',
        minWidth: '300px',
        maxWidth: props => props.maxWidth ? props.maxWidth : '320px'
    },
    contentRoot: {
        padding: '15px 24px',        
    },
    title: {
      fontSize: 14,
      marginBottom: 0,
      fontWeight: 'bold'
    },
    subtitle: {
      fontSize: 14,
      fontStyle: 'italic'
    },
    button: {      
      color: 'white',
      textDecoration: 'none',
      backgroundColor: '#1351b4',
      '&:hover': {
        background: '#003c8f',
        color: '#1351b4'
      }
      

    }
}));

const styles = theme => ({
    root: {
      margin: 0
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: '4px',
      color: theme.palette.grey[500],
      fontSize: '15px'
    },
  });

const DialogTitle = withStyles(styles)(props => {
    const { children, classes, handleClose } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root}>
        <Typography variant="h6">{children}</Typography>
        {handleClose ? (
          <IconButton aria-label="fechar" className={classes.closeButton} onClick={() => handleClose()}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

export default function MeuInssModal(props) {
    const classes = useStyles(props);

    return (
        <Dialog
            fullWidth
            onClose={() => props.handleClose()}
            open={props.open}
            classes={{paper: classes.dialogPaper}}>
            <DialogTitle {...props}>
                <Typography className={classes.title}>{props.title}</Typography>
                <Typography className={classes.subtitle}>{props.subtitle}</Typography>
            </DialogTitle>
            <DialogContent dividers classes={{root: classes.contentRoot}}>
                {props.children}
            </DialogContent>
            { props.action &&
              <DialogActions>
                <Button className={classes.button} onClick={(e) => props.handleAction(e)} disabled={props.actionDisabled} color="primary">
                    {props.action}
                </Button>
            </DialogActions> }
        </Dialog>
    )
}